import { useRef } from 'react';
import type { ChartDimensions } from '../types';
import useResizeObserver from 'use-resize-observer';

interface UseChartDimensionsProps {
  height: number;
  includeXAxis: boolean;
}

interface UseChartDimensionsResult {
  dimensions: ChartDimensions;
  wrapperRef: React.RefObject<HTMLDivElement>;
}

export const useChartDimensions = ({
  height,
  includeXAxis,
}: UseChartDimensionsProps): UseChartDimensionsResult => {
  const paddingX = 4;
  const paddingY = 6;
  const paddingBottom = includeXAxis ? 24 : paddingY;
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { width } = useResizeObserver<HTMLDivElement>({
    ref: wrapperRef,
  });
  const dimensions: ChartDimensions = {
    width: width ? Math.max(0, width - paddingX * 2) : 0,
    height,
    paddingX,
    paddingY,
    paddingBottom,
  };
  return { dimensions, wrapperRef };
};
